import {getPass} from "@khan/data-cookies";

import type {CookiesAPI} from "#data-access/cookies-provider.tsx";

const enabledCookie = "prototype-learn-enabled";

export const enableLearnPrototype = (cookies: CookiesAPI) => {
    cookies?.createCookie(
        enabledCookie,
        cookies.CookieCategory.StrictlyNecessary,
        "true",
        1,
    );
};

export const disableLearnPrototype = (cookies: CookiesAPI) => {
    cookies?.eraseCookie(enabledCookie);
};

export const isLearnPrototypeEnabled = (cookies: CookiesAPI): boolean => {
    return !!cookies.readCookie(enabledCookie) || !!getPass(enabledCookie);
};
